<template>
	<header>
		<div class="header-section">
			<div class="container-fluid">
				<div class="header-center">
					<router-link :to="{path: '/'}" class="header-logo">
						<img src="/assets/media/logo.png" alt="">
					</router-link>
					<div class="mixin-container d-xl-flex d-none">
						<form @submit.prevent="onSearch" class="w-100">
							<div class="input-field">
								<input type="text" name="search" id="searchInput" class="form-control header-search" placeholder="Поиск по товарам..." v-model="search">
								<button type="submit" class="cus-btn">Искать</button>
							</div>
						</form>
					</div>
					<div class="header-buttons">
						<router-link :to="{path: '/login'}" class="button-block align-items-sm-unset align-items-end" v-if="!authModel.isAuth()">
							<img src="/assets/media/users/user-3.png" alt="" class="user">
							<div>
								<p>Войти</p>
								<h6>Аккаунт</h6>
							</div>
						</router-link>
						<router-link :to="{path: '/account'}" class="button-block align-items-sm-unset align-items-end" v-if="authModel.isAuth()">
							<img src="/assets/media/users/user-3.png" alt="" class="user">
							<div>
								<p>Мой</p>
								<h6>Аккаунт</h6>
							</div>
						</router-link>
						<router-link :to="{path: '/wishlist'}" class="button-block d-sm-flex d-none position-relative">
							<svg width="30" height="30" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12.1,18.55L12,18.65L11.89,18.55C7.14,14.24 4,11.39 4,8.5C4,6.5 5.5,5 7.5,5C9.04,5 10.54,6 11.07,7.36H12.93C13.46,6 14.96,5 16.5,5C18.5,5 20,6.5 20,8.5C20,11.39 16.86,14.24 12.1,18.55M16.5,3C14.76,3 13.09,3.81 12,5.08C10.91,3.81 9.24,3 7.5,3C4.42,3 2,5.41 2,8.5C2,12.27 5.4,15.36 10.55,20.03L12,21.35L13.45,20.03C18.6,15.36 22,12.27 22,8.5C22,5.41 19.58,3 16.5,3Z" /></svg>
							<span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">{{appModel.wishlistProducts.length}}</span>
						</router-link>
						<router-link :to="{path: '/basket'}" class="button-block gap-3 d-sm-flex d-none">
							<span class="position-relative">
								<svg width="30" height="30" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M17,18A2,2 0 0,1 19,20A2,2 0 0,1 17,22C15.89,22 15,21.1 15,20C15,18.89 15.89,18 17,18M1,2H4.27L5.21,4H20A1,1 0 0,1 21,5C21,5.17 20.95,5.34 20.88,5.5L17.3,11.97C16.96,12.58 16.3,13 15.55,13H8.1L7.2,14.63L7.17,14.75A0.25,0.25 0 0,0 7.42,15H19V17H7C5.89,17 5,16.1 5,15C5,14.65 5.09,14.32 5.24,14.04L6.6,11.59L3,4H1V2M7,18A2,2 0 0,1 9,20A2,2 0 0,1 7,22C5.89,22 5,21.1 5,20C5,18.89 5.89,18 7,18M16,11L18.78,6H6.14L8.5,11H16Z" /></svg>
								<span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">{{appModel.basketProducts.length}}</span>
							</span>
							<div>
								<p>Корзина</p>
								<h6>{{number_format(basketSum)}}</h6>
							</div>
						</router-link>
					</div>
				</div>
				<div class="mixin-container d-xl-none d-flex">
					<form @submit.prevent="onSearch">
						<div class="input-field">
							<input type="text" name="search" id="searchInput2" class="form-control header-search" placeholder="Поиск по товарам..." v-model="search">
							<button type="submit" class="cus-btn">Искать</button>
						</div>
					</form>
				</div>
				
				<div class="header-bottom-area">
					<nav class="navigation d-flex align-items-center justify-content-between">
						<!-- Categories Dropdown -->
						<div class="nav-container">
							<nav class="all-category-nav">
								<label class="open-menu-all dropdown">
									<span class="all-navigator" data-bs-toggle="dropdown" aria-expanded="false">
										<i class="fas fa-bars" aria-hidden="true"></i> <span>Все категории</span>
									</span>
									<span class="all-category-list list-unstyled dropdown-menu">
										<span class="all-category-list-item" v-for="cat in productsCategories" :key="cat.id">
											<router-link :to="{path: '/catalog', query: {categories: appModel.getAllChildCategoryIds(cat.id)}}" class="all-category-list-link dark-black fw-500">{{cat.name}}</router-link>
										</span>
										<!--
										<span class="all-category-list-item">
											<router-link :to="{path: '/catalog'}" class="all-category-list-link dark-black fw-500">Value Of The Day</router-link>
										</span>
										<span class="all-category-list-item">
											<router-link :to="{path: '/catalog'}" class="all-category-list-link dark-black fw-500">Top 100 Offers</router-link>
										</span>
										<span class="all-category-list-item">
											<router-link :to="{path: '/catalog'}" class="all-category-list-link dark-black fw-500">New Arrivals</router-link>
										</span>
										<span class="all-category-list-item">
											<a href="javascript:;" class="all-category-list-link d-flex align-items-center justify-content-between">Laptop & Computer<i class="fas fa-angle-right" aria-hidden="true"></i></a>
											<span class="category-second-list border border-1">
												<span class="sub-menu-main-wrapper">
													<span class="wrapper-1">
														<span class="category-second-list-ul list-unstyled mb-40">
															<span class="dark-black fw-500 mb-16">Brands</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Apple </router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Dell</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Asus </router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Acer </router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">MSI </router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Lenovo </router-link>
															</span>
														</span>
														<span class="category-second-list-ul list-unstyled">
															<span class="dark-black fw-500 mb-16">Devices</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Printer and Ink</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Project and Screen</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Network Adaptor</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Photocopy and Scanner</router-link>
															</span>
														</span>
													</span>
													<span class="wrapper-1">
														<span class="category-second-list-ul list-unstyled mb-40">
															<span class="dark-black fw-500 mb-16">Models</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Office Computer</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Business Computer</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Gaming Computer</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Programming Computer</router-link>
															</span>
														</span>
														<span class="category-second-list-ul list-unstyled">
															<span class="dark-black fw-500 mb-16">Prices</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Up to $200</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">$500 to $1000</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">$1000 to $2000</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">$2000 to $3000</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">$3000 to $4000</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">$4000 to $5000</router-link>
															</span>
														</span>
													</span>
												</span>
												<span class="img-product-menu">
													<span class="image-content">
														<span class="h6 d-block fw-400 white mb-4p">LCD</span>
														<span class="h6 d-block fw-500 white mb-24">Radient View LCD</span>
														<span class="d-block text-16 white mb-4p">Just from:</span>
														<span class="d-block h4 color-ter mb-32">$840.99</span>
														<router-link :to="{path: '/catalog/1'}" class="cus-btn-3 sec">Купить</router-link>
													</span>
												</span>
											</span>
										</span>
										<span class="all-category-list-item">
											<a href="javascript:;" class="all-category-list-link d-flex align-items-center justify-content-between">Computer Hardware<i class="fas fa-angle-right" aria-hidden="true"></i></a>
											<span class="category-second-list border border-1">
												<span class="sub-menu-main-wrapper">
													<span class="wrapper-1">
														<span class="category-second-list-ul list-unstyled mb-40">
															<span class="dark-black fw-500 mb-16">Hardware</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">CPU, Processor </router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Motherboard</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">RAM, Memory</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">VGA, Graphic Card </router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">PSU, Power Supply</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Cooling Systems</router-link>
															</span>
														</span>
														<span class="category-second-list-ul list-unstyled">
															<span class="dark-black fw-500 mb-16">Others</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Security</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Barcode Scanner</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Attendence Machines</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Bill Counters</router-link>
															</span>
														</span>
													</span>
													<span class="wrapper-1">
														<span class="category-second-list-ul list-unstyled mb-40">
															<span class="dark-black fw-500 mb-16">Peripherals</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Mointer</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Mouse</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Keyboard</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Microphone</router-link>
															</span>
														</span>
													</span>
												</span>
												<span class="img-product-menu v-2">
													<span class="image-content">
														<span class="d-block h6 fw-400 white mb-4p">LAPTOP</span>
														<span class="d-block h6 fw-500 white mb-24">MACBOOK M1</span>
														<span class="d-block text-16 white mb-4p">Just from:</span>
														<span class="d-block h4 color-ter mb-32">$340.99</span>
														<router-link :to="{path: '/catalog/1'}" class="cus-btn-3 sec">Купить</router-link>
													</span>
												</span>
											</span>
										</span>
										<span class="all-category-list-item">
											<router-link :to="{path: '/catalog'}" class="all-category-list-link">Camera & Photo</router-link>
										</span>
										<span class="all-category-list-item">
											<a href="javascript:;" class="all-category-list-link d-flex align-items-center justify-content-between">Smartphone & Tablets<i class="fas fa-angle-right" aria-hidden="true"></i></a>
											<span class="category-second-list border border-1">
												<span class="sub-menu-main-wrapper">
													<span class="wrapper-1">
														<span class="category-second-list-ul list-unstyled mb-40">
															<span class="dark-black fw-500 mb-16">Brands</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Apple </router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Samsung</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Xiaomi</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Oppo </router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}"> Huawei</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Nokia </router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Vivo </router-link>
															</span>
														</span>
							
														<span class="category-second-list-ul list-unstyled">
															<span class="dark-black fw-500 mb-16">Display Sizes</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Up to 6 Inches</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">6 Inch - 8 Inch</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">8 Inch - 10 Inch</router-link>
															</span>
														</span>
							
													</span>
													<span class="wrapper-1">
														<span class="category-second-list-ul list-unstyled mb-40">
															<span class="dark-black fw-500 mb-16">Conditions</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">All New</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Renewed</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Refurbished</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Used</router-link>
															</span>
														</span>
														<span class="category-second-list-ul list-unstyled">
															<span class="dark-black fw-500 mb-16">Prices</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Up to $200</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">$500 to $1000</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">$1000 to $2000</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">$2000 to $3000</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">$3000 to $4000</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">$4000 to $5000</router-link>
															</span>
														</span>
													</span>
												</span>
												<span class="img-product-menu v-3">
													<span class="image-content">
														<span class="d-block h6 fw-400 white mb-4p">MOBILE</span>
														<span class="d-block h6 fw-500 white mb-24">Mobile Phone</span>
														<span class="text-16 white mb-4p">Just from:</span>
														<span class="d-block h4 color-ter mb-32">$500.99</span>
														<router-link :to="{path: '/catalog/1'}" class="cus-btn-3 sec">Купить</router-link>
													</span>
												</span>
											</span>
										</span>
										<span class="all-category-list-item">
											<a href="javascript:;" class="all-category-list-link d-flex align-items-center justify-content-between">TV & Audio<i class="fas fa-angle-right" aria-hidden="true"></i></a>
											<span class="category-second-list border border-1">
												<span class="sub-menu-main-wrapper">
													<span class="wrapper-1">
														<span class="category-second-list-ul list-unstyled mb-40">
															<span class="dark-black fw-500 mb-16">Brands</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Sony </router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">LG</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Samsung </router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Panasonic</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Toshiba </router-link>
															</span>
														</span>
														<span class="category-second-list-ul list-unstyled">
															<span class="dark-black fw-500 mb-16">Department</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Smart TVs</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">LED TVs</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Curved TVs</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">OLED TVs</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Plasma TVs</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Smart TVs 4K</router-link>
															</span>
														</span>
													</span>
													<span class="wrapper-1">
														<span class="category-second-list-ul list-unstyled">
															<span class="dark-black fw-500 mb-16">Prices</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">Up to $200</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">$500 to $1000</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">$1000 to $2000</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">$2000 to $3000</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">$3000 to $4000</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">$4000 to $5000</router-link>
															</span>
															<span class="category-second-item">
																<router-link :to="{path: '/catalog'}">$5000 to $6000</router-link>
															</span>
														</span>
													</span>
												</span>
												<span class="img-product-menu v-4">
													<span class="image-content">
														<span class="d-block h6 fw-400 white mb-4p">HEADPHONE</span>
														<span class="d-block h6 fw-500 white mb-24">Bass Headphones</span>
														<span class="text-16 white mb-4p">Just from:</span>
														<span class="d-block h4 color-ter mb-32">$180.00</span>
														<router-link :to="{path: '/catalog/1'}" class="cus-btn-3 sec">Купить</router-link>
													</span>
												</span>
											</span>
										</span>
										<span class="all-category-list-item">
											<router-link :to="{path: '/catalog'}" class="all-category-list-link">Home & Electronic</router-link>
										</span>
										<span class="all-category-list-item">
											<router-link :to="{path: '/catalog'}" class="all-category-list-link">Headphone & Speakers</router-link>
										</span>
										<span class="all-category-list-item">
											<router-link :to="{path: '/catalog'}" class="all-category-list-link">Watches & Eyewear</router-link>
										</span>
										<span class="all-category-list-item">
											<router-link :to="{path: '/catalog'}" class="all-category-list-link">Gamepad & Console</router-link>
										</span>
										-->
									</span>
								</label>
							</nav>
						</div>
						<!-- Categories Dropdown -->
						<div class="menu-button-right">
							<div class="main-menu__nav">
								<ul class="main-menu__list">
									<router-link custom :to="{path: '/'}" v-slot="{href, route, navigate, isActive, isExactActive}">
										<li>
											<a :href="href" @click="navigate" :class="[{'active': isExactActive}]">Главная</a>
										</li>
									</router-link>
									<router-link custom :to="{path: '/about'}" v-slot="{href, route, navigate, isActive, isExactActive}">
										<li>
											<a :href="href" @click="navigate" :class="[{'active': isExactActive}]">О магазине</a>
										</li>
									</router-link>
									<router-link custom :to="{path: '/catalog'}" v-slot="{href, route, navigate, isActive, isExactActive}">
										<li>
											<a :href="href" @click="navigate" :class="[{'active': isActive}]">Каталог товаров</a>
										</li>
									</router-link>
									<router-link custom :to="{path: '/news'}" v-slot="{href, route, navigate, isActive, isExactActive}">
										<li>
											<a :href="href" @click="navigate" :class="[{'active': isActive}]">Новости</a>
										</li>
									</router-link>
									<router-link custom :to="{path: '/contacts'}" v-slot="{href, route, navigate, isActive, isExactActive}">
										<li>
											<a :href="href" @click="navigate" :class="[{'active': isExactActive}]">Контакты</a>
										</li>
									</router-link>
									<router-link custom :to="{path: '/admin'}" v-slot="{href, route, navigate, isActive, isExactActive}" v-if="authModel.isAdmin()">
										<li>
											<a :href="href" @click="navigate" :class="[{'active': isActive}]">Админка</a>
										</li>
									</router-link>
								</ul>
							</div>
						</div>
						<div class="main-menu__right">
							<div class="d-sm-flex d-none gap-2">
								<p class="black fw-500"></p>
							</div>
							<a href="#" class="main-menu__toggler mobile-nav__toggler">
								<img src="/assets/media/icons/menu-2.png" alt="">
								Меню
							</a>
						</div>
					</nav>
				</div>
			</div>
		</div>
	</header>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	data: () => ({
		search: '',
	}),
	computed: {
		basketSum(){
			return this.appModel.basketProducts.reduce((sum, product) => sum + (product.price * product.count), 0);
		},
		productsCategories(){
			return this.appModel.productsCategories.filter(cat => !cat.parent_id);
		},
	},
	methods: {
		number_format(value){
			return lib.number_format(value, 0, '.', ' ');
		},
		
		onSearch() {
			const query = { ...this.$route.query, search: this.search };
			this.$router.push({ path: '/catalog', query });
		},
	},
}
</script>